import { AppColor } from "theme/app-color";
import Typography from "components/common/Typography";

interface InlineMessageProps {
  prefix: string;
  highlight: string;
  suffix: string;
}

const InlineMessage = ({ prefix, highlight, suffix }: InlineMessageProps) => {
  return (
    <div>
      <Typography
        variant="body1"
        color={AppColor["Text/Secondary"]}
        style={{ display: "inline" }}
        component="span"
      >
        {prefix}&nbsp;
      </Typography>
      <Typography
        variant="body2"
        color={AppColor["Text/Secondary"]}
        style={{ display: "inline" }}
        component="span"
      >
        {highlight}&nbsp;
      </Typography>
      <Typography
        variant="body1"
        color={AppColor["Text/Secondary"]}
        style={{ display: "inline" }}
        component="span"
      >
        {suffix}
      </Typography>
    </div>
  );
};

export default InlineMessage;
